import React, { useState } from "react";
import { Row, Col, Card, Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CommonButton from "../Input/CommonButton";
import RateTab from "./components/RateTab";
import ServiceChargeTab from "./components/ServiceChargeTab";

const Dashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("rate");

  const walletData = [
    {
      title: "Sparkminds wallet (SGD)",
      amount: "75.93",
      currency: "SGD",
      pending: "S$ 233.243",
      icon: "fas fa-wallet",
    },
    {
      title: "Sparkminds wallet (USD)",
      amount: "10,000,000,197.1",
      currency: "USD",
      pending: "$ 134.493",
      icon: "fas fa-wallet",
    },
  ];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold text-black mb-0">Dashboard</h2>
        <CommonButton
          variant="primary"
          onClick={() => navigate("/top-up")}
          className="d-flex align-items-center  border-0"
        >
          Topup <i className="fas fa-arrow-right ms-2"></i>
        </CommonButton>
      </div>

      <Row className="mb-4">
        {walletData.map((wallet, index) => (
          <Col xl={6} lg={6} md={6} key={index} className="mb-2">
            <Card className="border-0 shadow-sm rounded-4 h-100  wallet-card-premium">
              <Card.Body className="p-4">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <span className="fw-bold text-black opacity-75">
                    {wallet.title}
                  </span>
                  <div className="text-muted">
                    <i className="fas fa-wallet cursor-pointer"></i>
                  </div>
                </div>
                <div className="mb-2">
                  <h2 className="fw-bold text-black mb-0">
                    {wallet.amount}{" "}
                    <span className="fs-18">{wallet.currency}</span>
                  </h2>
                </div>
                <div className="text-muted fs-13">
                  Pending: {wallet.pending}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <div className="custom-tab-wrapper">
        <Nav as="ul" className="nav-tabs custom-tabs-1 mb-3">
          <Nav.Item as="li">
            <Nav.Link
              className={activeTab === "rate" ? "active" : ""}
              onClick={() => setActiveTab("rate")}
            >
              Rate
            </Nav.Link>
          </Nav.Item>
          <Nav.Item as="li">
            <Nav.Link
              className={activeTab === "service" ? "active" : ""}
              onClick={() => setActiveTab("service")}
            >
              Service charge
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Card className="border-0 mt-2 shadow-sm rounded-4 overflow-hidden">
          <Card.Body className="p-0">
            {activeTab === "rate" ? <RateTab /> : <ServiceChargeTab />}
          </Card.Body>
        </Card>
      </div>

      <style>{`
                .wallet-card-premium {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    border: 1px solid #f0f0f0 !important;
                }
                .wallet-card-premium:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.05) !important;
                }
                .bg-dark-blue {
                    background-color: #00264D !important;
                }
                .custom-tabs-1 .nav-link {
                    border: none;
                    background: none;
                    color: #6c757d;
                    font-weight: 500;
                    padding: 10px 20px;
                    border-bottom: 2px solid transparent;
                    transition: all 0.3s ease;
                }
                .custom-tabs-1 .nav-link.active {
                    color: #00264D;
                    border-bottom: 2px solid #00264D;
                    background: none;
                }
                .custom-tabs-1 .nav-link:hover:not(.active) {
                    color: #333;
                }
                .fs-18 { font-size: 18px; }
                .fs-13 { font-size: 13px; }
            `}</style>
    </div>
  );
};

export default Dashboard;
